import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import { navigate } from 'state/router'
import { FacebookFeedCardDisplay, Props } from './FacebookFeedCard.display'

const mapStateToProps = () => ({})

type DispatchProps = Pick<Props, 'navigate'>

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  navigate: viewId => {
    dispatch(navigate({ viewId }))
  }
})

export const FacebookFeedCardContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FacebookFeedCardDisplay)
